// Thin client-side wrappers around the named custom mutators defined in
// packages/zero-schema/src/mutators.ts. The Zero client runs them locally
// (optimistic) and pushes them to /api/zero/push on the Worker for the
// authoritative write.
import type { Zero } from "@rocicorp/zero";
import type { Mutators, schema } from "@lovd/zero-schema";

type Z = Zero<typeof schema, Mutators>;

export async function createCollection(
  z: Z,
  _ownerUserId: string,
  { name, themeColor }: { name: string; themeColor?: string },
): Promise<string> {
  const id = crypto.randomUUID();
  await z.mutate.collections.create({
    id,
    name,
    themeColor: themeColor ?? null,
  });
  return id;
}

export async function createPhotoEntry(
  z: Z,
  _authorUserId: string,
  collectionId: string,
  mediaId: string,
  { title }: { title?: string } = {},
): Promise<string> {
  const id = crypto.randomUUID();
  await z.mutate.entries.createPhoto({
    id,
    collectionId,
    mediaId,
    title: title ?? null,
  });
  return id;
}
